import React from 'react'
import { Card, Divider } from 'semantic-ui-react'
import { LinkCard } from '@bsd/dashboard-toolkit/components'

import cards from './settingsCards'

export default class SettingsHome extends React.Component {

  renderCard = (card) => {
    const { match } = this.props
    if (card.type === 'group') {
      return this.renderGroup(card)
    }
    return (
      <LinkCard
        key={card.key}
        link={{
          to: card.to.replace('{{matchUrl}}', match.url),
          name: card.name,
          icon: card.icon,
          description: card.description,
        }}
      />
    )
  }

  renderGroup = (group) => {
    return (
      <div key={group.key}>
        <Divider horizontal>{group.name}</Divider>
        <Card.Group>
          {group.cards.map(this.renderCard)}
        </Card.Group>
      </div>
    )
  }

  render() {
    return (
      <div style={{ padding: '15px' }}>
        {cards.map(this.renderCard)}
      </div>
    )
  }
}